import { render, staticRenderFns } from "./RootView.vue?vue&type=template&id=b1653cda&scoped=true"
import script from "./RootView.vue?vue&type=script&lang=js"
export * from "./RootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1653cda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1653cda')) {
      api.createRecord('b1653cda', component.options)
    } else {
      api.reload('b1653cda', component.options)
    }
    module.hot.accept("./RootView.vue?vue&type=template&id=b1653cda&scoped=true", function () {
      api.rerender('b1653cda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mmaps/RootView.vue"
export default component.exports